import React from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";
import { device } from "../../services/styles";

const Box = styled.div`
  background-color: #f1f1f1;
  padding: 20px 10px;
  margin: 0 0 20px 0;
  width: 100%;
  @media ${device.tablet} {
    width: 400px;
    padding: 20px;
    margin-right: 20px;
  }
  .wysiwyg ul {
    margin-bottom: -18px;
  }
`;
export const Header = styled.p`
  font-size: 20px;
  line-height: 24px;
  font-weight: 900;
  text-transform: uppercase;
  margin: 0;
`;

function TopicsCovered({ topics }) {
  return (
    <Box>
      <Header>Z artykułu dowiesz się</Header>
      <div className={"wysiwyg"}>{ReactHtmlParser(topics)}</div>
    </Box>
  );
}

export default TopicsCovered;
